import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import Components from "./pages";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/OtherPage";
import TicketDetails from "./pages/TicketDetails";
import TicketsTable from "./pages/Tickets";
import UnitTable from "./pages/UnitGroups";
import UnitDetails from "./pages/UnitGroups/Components/UnitDetails";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Auth/Login";
import UserManagement from "./pages/UserManagement";
import ManageRole from "./pages/UserManagement/Components/ManageRoles";
import Register from "./pages/Auth/Register";
import { useAutoAdminSessionRefresh } from "./hooks/useAdminSessionRefresh";
const App: React.FC = () => {
  useAutoAdminSessionRefresh();

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tickets" element={<TicketsTable />} />
          <Route path="/tickets/d/:id" element={<TicketDetails />} />
          <Route path="/unit" element={<UnitTable />} />
          <Route path="/unit/d/:id" element={<UnitDetails />} />
          <Route path="/user" element={<UserManagement />} />
          <Route path="/user-role" element={<ManageRole />} />
          <Route path="/components" element={<Components />} />
        </Route>

        {/* 404 fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
